// Dynamic imports for routes that are code-split out of the main bundle (AB#2926).
// Browsers cache module promises, so a preload and the later `lazy()` render share one request.
export const loadDistributionDashboard = () => import('@/pages/distribution-dashboards');
export const loadCartManagement = () => import('@/pages/cart-management');
